import React from 'react';
import PropTypes from 'prop-types';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import SmartInput from 'react-phone-number-input/smart-input';
import styles from './PhoneInputField.css';

const PhoneInputField = ({
  defaultCountry,
  disabled,
  onChange,
  value,
  ...rest
}) => (
  <PhoneInput
    country={defaultCountry}
    countryOptions={[
      'US',
      '|',
      '...'
    ]}
    className={styles.phoneContainer}
    disabled={disabled}
    displayInitialValueAsLocalNumber={true}
    inputComponent={SmartInput}
    inputClassName={styles.phoneInput}
    onChange={onChange}
    value={value}
    {...rest}
  />
);

PhoneInputField.propTypes = {
  defaultCountry: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

PhoneInputField.defaultProps = {
  defaultCountry: 'US',
};

export default PhoneInputField;
